import React from 'react';
import { Section } from './Section';
import { Droplets, Check } from 'lucide-react';
export function MechanismSection() {
  const chips = ['simple', 'corto', 'claro', 'fácil de seguir', 'pensado para la vida real'];
  return <Section className="bg-forest text-cream" data-id="element-298">
      <div className="text-center mb-10" data-id="element-299">
        <Droplets className="w-12 h-12 text-gold mx-auto mb-4" data-id="element-300" />
        <h2 className="font-serif text-3xl md:text-4xl font-bold mb-6" data-id="element-301">
          Por eso creamos Adiós Hinchazón: 3-Day Reset
        </h2>
      </div>
      <div className="bg-forest-light rounded-2xl p-8 md:p-10 border border-forest" data-id="element-302">
        <p className="text-lg leading-relaxed text-cream-dark mb-8 text-center" data-id="element-303">
          Un plan práctico de 3 días creado para ayudar a mujeres ocupadas a
          deshinchar abdomen y cuerpo, apoyar una menor retención de líquidos y
          sentirse más ligeras sin complicarse la vida.
        </p>
        <div className="flex flex-wrap justify-center gap-3" data-id="element-304">
          {chips.map((chip, i) => <div key={i} className="bg-forest text-gold px-4 py-2 rounded-full text-sm font-bold uppercase tracking-wider flex items-center gap-2 border border-gold/30" data-id="element-305">
              <Check className="w-4 h-4" data-id="element-306" />
              {chip}
            </div>)}
        </div>
      </div>
    </Section>;
}